import React from 'react'
import mount from '../lib/mount'
import App from '../components/App'
import ProtipSubscribeButton from '../components/ProtipSubscribeButton'

document.addEventListener('turbolinks:load', () => {
  const node = document.getElementById('react-protip-subscribe-button')
  if (node) {
    mount(
      node,
      <App>
        <ProtipSubscribeButton />
      </App>,
    )
  }
})
